<template>
  <div class="wrapper-exam line-numbers">
    <div v-if="CurrentQuestion.subject_id == 3">
      <el-button @click="CloseDrawer" v-if="drawer" size="medium" style="position: fixed;z-index: 10000; float: right; right: 20px; margin-top:-16px;background: #66b1ff7d;
                color: white;
                border: 0px;">
        <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
          <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
          <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
          <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
        </svg>
        返回试卷
      </el-button>

      <el-button @click="OpenDrawer" v-if="drawer" size="medium" style="position: fixed;z-index: 10000; float: right;margin-top:-16px;right:150px;background: #66b1ff7d;
                color: white;
                border: 0px;">
        <svg t="1665543507850" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4723" width="15" height="15">
          <path d="M811.115789 1005.136842H212.884211a194.290526 194.290526 0 0 1-194.021053-194.021053V212.884211A194.290526 194.290526 0 0 1 212.884211 18.863158h598.231578a194.290526 194.290526 0 0 1 194.021053 194.021053v598.231578a194.290526 194.290526 0 0 1-194.021053 194.021053zM212.884211 72.757895a140.126316 140.126316 0 0 0-140.126316 140.126316v598.231578a140.126316 140.126316 0 0 0 140.126316 140.126316h598.231578a140.126316 140.126316 0 0 0 140.126316-140.126316V212.884211a140.126316 140.126316 0 0 0-140.126316-140.126316z" p-id="4724" fill="#ffffff"></path>
          <path d="M788.210526 350.315789H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 350.315789H233.903158a26.947368 26.947368 0 0 1 0-53.894736h58.206316a26.947368 26.947368 0 0 1 0 53.894736zM788.210526 538.947368H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 540.564211H233.903158a26.947368 26.947368 0 0 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737zM788.210526 745.094737H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 746.442105H233.903158a26.947368 26.947368 0 1 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737z" p-id="4725" fill="#ffffff"></path>
        </svg>
        题目说明
      </el-button>

      <el-button @click="OpenDrawer" v-if="drawer" size="medium" style="position: fixed;z-index: 10000; float: right;margin-top:-16px;right:280px;background: #66b1ff7d;
                color: white;
                border: 0px;">
        <svg t="1665622297666" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2845" width="15" height="15">
          <path d="M602.965333 882.176A381.098667 381.098667 0 1 1 512 130.901333a382.976 382.976 0 0 1 376.832 324.266667 17.066667 17.066667 0 0 0 19.456 14.336 17.066667 17.066667 0 0 0 14.336-19.456A415.232 415.232 0 1 0 512 927.232a420.181333 420.181333 0 0 0 99.157333-11.776 17.066667 17.066667 0 0 0 12.458667-20.650667 17.066667 17.066667 0 0 0-20.650667-12.629333z" fill="#ffffff" p-id="2846"></path>
          <path d="M543.402667 732.330667a17.066667 17.066667 0 1 0 0-34.133334h-62.805334a17.066667 17.066667 0 1 0 0 34.133334z" fill="#ffffff" p-id="2847"></path>
          <path d="M603.989333 816.810667a317.44 317.44 0 0 1-74.922666 12.8v-24.234667a17.066667 17.066667 0 0 0-34.133334 0v24.064a316.074667 316.074667 0 0 1-126.976-34.133333l12.117334-20.821334a17.066667 17.066667 0 1 0-29.525334-17.066666l-12.117333 20.821333a320.853333 320.853333 0 0 1-92.842667-92.842667l20.821334-12.117333a17.066667 17.066667 0 1 0-17.066667-29.525333l-20.821333 12.117333a316.074667 316.074667 0 0 1-34.133334-126.976h24.064a17.066667 17.066667 0 1 0 0-34.133333h-23.893333a316.074667 316.074667 0 0 1 34.133333-126.976l20.821334 12.117333a17.066667 17.066667 0 1 0 17.066666-29.525333l-20.821333-12.117334a320.853333 320.853333 0 0 1 92.842667-92.842666l12.117333 20.821333a17.066667 17.066667 0 1 0 29.525333-17.066667l-12.117333-20.821333a316.074667 316.074667 0 0 1 126.976-34.133333v24.064a17.066667 17.066667 0 1 0 34.133333 0V194.56a314.88 314.88 0 0 1 126.976 34.133333l-12.117333 20.821334a17.066667 17.066667 0 1 0 29.525333 17.066666l12.117334-20.821333a319.317333 319.317333 0 0 1 93.013333 92.842667l-20.992 12.117333a17.066667 17.066667 0 1 0 17.066667 29.525333l20.992-12.117333a312.832 312.832 0 0 1 29.013333 84.138667 17.066667 17.066667 0 1 0 34.133333-6.314667A352.256 352.256 0 1 0 614.4 849.408a17.066667 17.066667 0 0 0 11.434667-21.162667 17.066667 17.066667 0 0 0-21.845334-11.434666z" fill="#ffffff" p-id="2848"></path>
          <path d="M512 491.008A20.992 20.992 0 1 0 532.992 512 20.992 20.992 0 0 0 512 491.008z" fill="#ffffff" p-id="2849"></path>
          <path d="M565.76 571.050667A80.042667 80.042667 0 0 0 592.213333 512a74.410667 74.410667 0 0 0-1.194666-10.581333l110.08-109.909334a48.469333 48.469333 0 1 0-68.266667-68.266666l-109.909333 110.08a74.410667 74.410667 0 0 0-10.922667-1.536 75.605333 75.605333 0 0 0-21.504 3.413333l-91.648-69.12A48.469333 48.469333 0 1 0 341.333333 443.733333l91.477334 68.266667A80.213333 80.213333 0 0 0 512 592.213333a76.117333 76.117333 0 0 0 24.234667-4.266666l78.336 136.533333a17.066667 17.066667 0 0 0 29.525333-17.066667z m90.794667-223.914667a14.336 14.336 0 0 1 20.309333 20.309333l-98.986667 98.986667a82.090667 82.090667 0 0 0-20.309333-20.309333zM440.661333 476.16l-79.530666-59.904a14.336 14.336 0 1 1 17.066666-22.869333l79.530667 59.904a83.968 83.968 0 0 0-17.066667 22.869333zM512 558.08a46.08 46.08 0 1 1 46.08-46.08 46.08 46.08 0 0 1-46.08 46.08z" fill="#ffffff" p-id="2850"></path>
          <path d="M892.586667 646.314667v-30.72a34.133333 34.133333 0 0 0 34.133333-34.133334v-39.765333a17.066667 17.066667 0 0 0-17.066667-17.066667H681.642667a17.066667 17.066667 0 0 0-17.066667 17.066667v39.765333a34.133333 34.133333 0 0 0 34.133333 34.133334v30.72a96.597333 96.597333 0 0 0 41.984 79.530666A97.109333 97.109333 0 0 0 699.733333 805.546667V836.266667a34.133333 34.133333 0 0 0-34.133333 34.133333v39.765333a17.066667 17.066667 0 0 0 17.066667 17.066667h227.498666a17.066667 17.066667 0 0 0 17.066667-17.066667V870.4a34.133333 34.133333 0 0 0-34.133333-34.133333v-30.72a97.109333 97.109333 0 0 0-41.813334-79.701334 96.426667 96.426667 0 0 0 41.301334-79.530666z m-193.877334-64.853334v-22.698666h194.389334v22.698666zM893.098667 870.4v22.698667H698.709333V870.4z m-34.133334-64.853333V836.266667H733.866667v-30.72a62.634667 62.634667 0 1 1 125.098666 0z m0-159.232a62.634667 62.634667 0 0 1-125.098666 0v-30.72h124.586666z" fill="#ffffff" p-id="2851"></path>
        </svg>
        {{
          hour
            ? hourString + ":" + minuteString + ":" + secondString
            : minuteString + ":" + secondString
        }}
      </el-button>
    </div>

    <div v-if="CurrentQuestion.subject_id == 2 && !FullScreen_state">
      <div v-if="drawer" style="position: fixed;z-index: 10000;float: right;right: 220px;margin-top: -22px;color: #fff;line-height: 36px;font-size: 20px;" class="zonghe-time">
        <i class="el-icon-alarm-clock" style="margin-right: 5px;"></i>
        <span class="time">{{
          hourString + ":" + minuteString + ":" + secondString
        }}</span>
      </div>
      <el-button @click="CloseDrawer" v-if="drawer" size="medium" style="position: fixed;z-index: 10000; float: right; right: 10px; margin-top:-22px;background: #66b1ff7d;
                color: white;
                border: 0px;">
        <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
          <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
          <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
          <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
        </svg>
        返回
      </el-button>

      <el-button @click="OpenDrawer" v-if="drawer" size="medium" style="position: fixed;z-index: 10000; float: right;margin-top:-22px;right:110px;background: #66b1ff7d;
                color: white;
                border: 0px;">
        <svg t="1665543507850" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4723" width="15" height="15">
          <path d="M811.115789 1005.136842H212.884211a194.290526 194.290526 0 0 1-194.021053-194.021053V212.884211A194.290526 194.290526 0 0 1 212.884211 18.863158h598.231578a194.290526 194.290526 0 0 1 194.021053 194.021053v598.231578a194.290526 194.290526 0 0 1-194.021053 194.021053zM212.884211 72.757895a140.126316 140.126316 0 0 0-140.126316 140.126316v598.231578a140.126316 140.126316 0 0 0 140.126316 140.126316h598.231578a140.126316 140.126316 0 0 0 140.126316-140.126316V212.884211a140.126316 140.126316 0 0 0-140.126316-140.126316z" p-id="4724" fill="#ffffff"></path>
          <path d="M788.210526 350.315789H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 350.315789H233.903158a26.947368 26.947368 0 0 1 0-53.894736h58.206316a26.947368 26.947368 0 0 1 0 53.894736zM788.210526 538.947368H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 540.564211H233.903158a26.947368 26.947368 0 0 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737zM788.210526 745.094737H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 746.442105H233.903158a26.947368 26.947368 0 1 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737z" p-id="4725" fill="#ffffff"></path>
        </svg>
        题目
      </el-button>
    </div>

    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item style="cursor: pointer" @click.native="goback">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        <el-breadcrumb-item>在线考试</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row class="question" :gutter="20">
      <el-col :span="18">
        <el-card shadow="never">
          <div class="question-wrapper">
            <div class="exam_wrapper">
              <div class="exam_title">{{ title }}</div>
              <div class="exam_set">
                <span class="exam_label">考试题数:</span>
                <span class="exam_txt">{{ paper.total_num }}</span>
                <span class="exam_label">考试时间:</span>
                <span class="exam_txt">{{ exam.lasttime / 60 }}分钟</span>
                <span class="exam_label">满分:</span>
                <span class="exam_txt">{{ paper.total_score }}分</span>
                <span class="exam_label">及格分:</span>
                <span class="exam_txt">{{ exam.passscore }}分</span>
              </div>
            </div>

            <el-divider></el-divider>

            <el-row>
              <el-col :span="6">
                <div class="question-header">
                  <span style="font-size: 16px;font-weight: bold">第 {{ CurrentQuestion.index + 1 }} 题</span>

                  <span v-if="CurrentQuestion.type == '1'" style="font-size: 16px;">【单选题】</span>
                  <span v-if="CurrentQuestion.type == '2'" style="font-size: 16px;">【多选题】</span>
                  <span v-if="CurrentQuestion.type == '3'" style="font-size: 16px;">【判断题】</span>
                  <span v-if="CurrentQuestion.type == '4'" style="font-size: 16px;">【填空题】</span>
                  <span v-if="CurrentQuestion.type == '5'" style="font-size: 16px;">【简答题】</span>
                  <span v-if="CurrentQuestion.type == '6'" style="font-size: 16px;">【综合题】</span>
                  <span v-if="CurrentQuestion.type == '7'" style="font-size: 16px;">【阅读程序题】</span>
                  <span v-if="CurrentQuestion.type == '8'" style="font-size: 16px;">【完善程序题】</span>
                  <span v-if="CurrentQuestion.type == '9'" style="font-size: 16px;">【编程题】</span>
                  <span style="font-size: 16px;">({{ CurrentQuestion.score }}分)</span>
                </div>
              </el-col>
              <el-col :span="18">
                <div class="question-btn">
                  <el-button size="mini" :disabled="prebtn" type="primary" round @click="PreQuestion">上一题</el-button>
                  <el-button size="mini" :disabled="nextbtn" type="primary" round @click="NextQuestion">下一题</el-button>
                </div>
              </el-col>
            </el-row>

            <!--答题区-->

            <div class="question-content">
              <!--题目标题-->
              <div style="margin-top:10px;">
                <span v-if="CurrentQuestion.show_type === 1">
                  <span v-if="
                      CurrentQuestion.type == 7 || CurrentQuestion.type == 8
                    ">
                    <div class="question-title" v-html="CurrentQuestion.title_other"></div>
                    <div style="margin-top:20px;font-size: 16px;" v-html="CurrentQuestion.title"></div>
                  </span>
                  <span v-else>
                    <span v-if="CurrentQuestion.type == 9">{{CurrentQuestion.ojProblemInfo.code}} {{CurrentQuestion.ojProblemInfo.title}}</span>
                    <span v-else v-html="CurrentQuestion.title"></span>
                  </span>
                </span>
                <span class="question-title" v-else>
                  <span v-if="
                      CurrentQuestion.type == 7 || CurrentQuestion.type == 8
                    ">
                    <div>
                      <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="CurrentQuestion.title_other_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="CurrentQuestion.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                  <span v-else>
                    <span v-if="CurrentQuestion.type == 9">{{CurrentQuestion.ojProblemInfo.code}} {{CurrentQuestion.ojProblemInfo.title}}</span>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-else v-model="CurrentQuestion.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                </span>
              </div>

              <!--单选题作答区-->
              <div class="answer-otions" style="margin-top:20px;font-size: 16px;" v-if="CurrentQuestion.options && CurrentQuestion.type == '1'">
                <div v-if="CurrentQuestion.show_type === 1">
                  <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                      CurrentQuestion.options
                    )" :key="index">
                    <span class="option-tab" v-if="option.content">
                      <el-radio :disabled="disabled1" v-model="
                          paperQuestionList[CurrentQuestion.index].stu_answer
                        " :label="option.title" @change="checkAddType" @click.native="
                          checkSingleQuestion(option.title, '1', $event)
                        ">{{ option.title }}</el-radio>
                    </span>

                    <div class="option-input" v-if="option.content" v-html="option.content"></div>
                  </div>
                </div>
                <div v-else>
                  <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                      CurrentQuestion.options_md
                    )" :key="index">
                    <span class="option-tab" v-if="option.content">
                      <el-radio :disabled="disabled1" v-model="
                          paperQuestionList[CurrentQuestion.index].stu_answer
                        " :label="option.title" @change="checkAddType" @click.native="
                          checkSingleQuestion(option.title, '1', $event)
                        ">{{ option.title }}</el-radio>
                    </span>

                    <div class="option-input" v-if="option.content">
                      <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                  </div>
                </div>
              </div>

              <!--多选题作答区-->
              <div class="answer-otions" v-if="CurrentQuestion.options && CurrentQuestion.type == '2'">
                <div v-if="CurrentQuestion.show_type === 1">
                  <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                      CurrentQuestion.options
                    )" :key="index">
                    <span class="option-tab" v-if="option.content">
                      <el-checkbox @change="checkAddType" v-model="CurrentQuestion.answers[index]" :label="option.title">
                        {{ option.title }}</el-checkbox>
                    </span>
                    <div class="option-input" v-if="option.content" v-html="option.content"></div>
                  </div>
                </div>
                <div v-else>
                  <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                      CurrentQuestion.options_md
                    )" :key="index">
                    <span class="option-tab" v-if="option.content">
                      <el-checkbox @change="checkAddType" v-model="CurrentQuestion.answers[index]" :label="option.title">
                        {{ option.title }}</el-checkbox>
                    </span>
                    <div class="option-input" v-if="option.content">
                      <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                  </div>
                </div>

                <el-button size="mini" type="primary" @click="SubmitAnswer" :disabled="disabled1">
                  提交答案</el-button>
              </div>

              <!--判断题作答区-->
              <div class="answer-otions" v-if="CurrentQuestion.options && CurrentQuestion.type == '3'">
                <div class="option-wrapper" v-for="(option, index) of JSON.parse(CurrentQuestion.options)" :key="index">
                  <span class="option-tab" v-if="option.content">
                    <el-radio v-model="
                        paperQuestionList[CurrentQuestion.index].stu_answer
                      " :label="option.title" @click.native="
                        checkSingleQuestion(option.title, '2', $event)
                      ">{{ option.title }}</el-radio>
                  </span>

                  <div class="option-input" v-if="option.content" v-html="option.content"></div>
                </div>
              </div>

              <!--填空题作答区-->
              <div class="answer-otions" v-if="CurrentQuestion.options && CurrentQuestion.type == '4'">
                <div class="option-wrapper" v-for="count in CurrentQuestion.tiankong_num" :key="count">
                  <el-input @input="checkAddType" v-model="CurrentQuestion.space_answers[count - 1]" :placeholder="'请输入第' + count + '个空的作答内容'"></el-input>
                </div>

                <el-button size="mini" type="primary" @click="SubmitSpaceAnswer">
                  提交答案</el-button>
              </div>

              <!--简答题作答区-->
              <div class="answer-otions" v-if="CurrentQuestion.options && CurrentQuestion.type == '5'">
                <el-input type="textarea" :rows="8" @input="checkAddType" v-model="CurrentQuestion.blank_answer" :placeholder="'请输入作答内容'"></el-input>

                <el-button style="margin-top: 20px" size="mini" type="primary" @click="SubmitBlankAnswer">
                  提交答案</el-button>
              </div>

              <!--综合题作答区-->
              <div class="gocreate" v-if="CurrentQuestion.type == '6'">
                <el-button type="primary" icon="el-icon-thumb" @click="GoCreate">开始创作</el-button>

                <el-row style="margin-top: 20px; width: 240px" v-if="
                    CurrentQuestion.stu_answer &&
                      !drawer &&
                      (CurrentQuestion.subject_id == 2 ||
                        CurrentQuestion.subject_id == 1)
                  ">
                  <el-card :body-style="{ padding: '0px' }">
                    <img :src="CurrentQuestion.stu_answer.split(',')[1]" class="image" @click="GoCreate" />
                    <div style="padding: 14px">
                      <span>{{
                        CurrentQuestion.stu_answer.split(",")[0]
                      }}</span>
                    </div>
                  </el-card>
                </el-row>
              </div>
              <!-- 阅读程序题 -->
              <div class="answer-otions" v-if="CurrentQuestion.options && CurrentQuestion.type == '7'">
                <div v-if="CurrentQuestion.show_type === 1">
                  <!--阅读题为单选题-->
                  <div v-if="CurrentQuestion.type_other == 1" style="margin-top:20px;">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio :disabled="disabled1" @change="checkAddType" v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title" @click.native="
                            checkSingleQuestion(option.title, '1', $event)
                          ">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content" v-html="option.content"></div>
                    </div>
                  </div>
                  <!--阅读题为判断题-->
                  <div v-if="CurrentQuestion.type_other == 3" style="margin-top:20px;">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio @click.native="
                            checkSingleQuestion(option.title, '2', $event)
                          " v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content" v-html="option.content"></div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="CurrentQuestion.type_other == 1">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options_md
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio :disabled="disabled1" @change="checkAddType" @click.native="
                            checkSingleQuestion(option.title, '1', $event)
                          " v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content">
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>
                  <div v-if="CurrentQuestion.type_other == 3">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio @click.native="
                            checkSingleQuestion(option.title, '2', $event)
                          " v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content" v-html="option.content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 完善程序题 -->
              <div class="answer-otions" v-if="CurrentQuestion.options && CurrentQuestion.type == '8'">
                <div v-if="CurrentQuestion.show_type === 1">
                  <!--完善程序题为单选题-->
                  <div v-if="CurrentQuestion.type_other == 1">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio :disabled="disabled1" @change="checkAddType" v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title" @click.native="
                            checkSingleQuestion(option.title, '1', $event)
                          ">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content" v-html="option.content"></div>
                    </div>
                  </div>
                  <!--完善程序题为判断题-->
                  <div v-if="CurrentQuestion.type_other == 3" style="margin-top:20px;">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio @click.native="
                            checkSingleQuestion(option.title, '2', $event)
                          " v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content" v-html="option.content"></div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="CurrentQuestion.type_other == 1">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options_md
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio :disabled="disabled1" @change="checkAddType" v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title" @click.native="
                            checkSingleQuestion(option.title, '1', $event)
                          ">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content">
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>
                  <div v-if="CurrentQuestion.type_other == 3">
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(
                        CurrentQuestion.options
                      )" :key="index">
                      <span class="option-tab" v-if="option.content">
                        <el-radio @click.native="
                            checkSingleQuestion(option.title, '2', $event)
                          " v-model="
                            paperQuestionList[CurrentQuestion.index].stu_answer
                          " :label="option.title">{{ option.title }}</el-radio>
                      </span>

                      <div class="option-input" v-if="option.content" v-html="option.content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 编程题 -->
              <div class="answer-otions" v-if="CurrentQuestion && CurrentQuestion.type == '9'">
                <div class="question-content">
                  <div class="question-body" style="padding-top:10px;margin-bottom:20px;font-size:16px">
                    <template v-if="CurrentQuestion.ojProblemInfo.description_show_type === 1">
                      <div class="desc">
                        <strong style="display: inline-block;width:100%">描述</strong>
                        <span v-html="CurrentQuestion.ojProblemInfo.description"></span>
                      </div>
                      <div class="desc-input" style="margin-bottom:10px;">
                        <strong>输入描述</strong>
                        <p v-html="CurrentQuestion.ojProblemInfo.input_description"></p>
                      </div>
                      <div class="desc-output" style="margin-bottom:10px;">
                        <strong>输出描述</strong>
                        <p v-html="CurrentQuestion.ojProblemInfo.output_description"></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="desc">
                        <strong style="display: inline-block;width:100%">描述</strong>
                        <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="CurrentQuestion.ojProblemInfo.md_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                      <div class="desc-input" style="margin-bottom:10px;">
                        <strong>输入描述</strong>
                        <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="CurrentQuestion.ojProblemInfo.md_input_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                      <div class="desc-output" style="margin-bottom:10px;">
                        <strong>输出描述</strong>
                        <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="CurrentQuestion.ojProblemInfo.md_output_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </template>
                    <div class="input-samples" style="margin-bottom:10px;">
                      <div v-for="(sample, i) in JSON.parse(CurrentQuestion.ojProblemInfo.samples)" :key="i">
                        <strong class="title">输入样例 {{ i + 1 }}</strong>
                        <!-- <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags" :data-clipboard-text="sample.input" @click="copyText" size="mini">复制</el-tag></span> -->
                        <pre class="language-c" style="border:1px solid #ddd;padding:10px;border-radius:5px;margin-top:5px">{{ sample.input }}</pre>
                      </div>
                    </div>
                    <div class="output-samples" style="margin-bottom:10px;">
                      <div v-for="(sample, i) in JSON.parse(CurrentQuestion.ojProblemInfo.samples)" :key="i">
                        <strong class="title">输出样例 {{ i + 1 }}</strong>
                        <!-- <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags" :data-clipboard-text="sample.output" @click="copyText" size="mini">复制</el-tag></span> -->
                        <pre class="language-c" style="border:1px solid #ddd;padding:10px;border-radius:5px;margin-top:5px">{{ sample.output }}</pre>
                      </div>
                    </div>
                  </div>
                </div>

                <!--正确答案-->
                <div class="answerinfo">
                  <el-button style="margin-left:10px;" icon="el-icon-edit-outline" type="primary" size="small" round @click="handleCodeMirrorInfoDrawer(true,CurrentQuestion)">开始作答</el-button>
                  <!-- <div class="answer-correct">
                    <span class="corrent-label">正确答案:</span>
                    <el-button v-if="CurrentQuestion.type==9" style="margin-left:10px;" type="primary" size="small" round @click="handleCodeMirrorInfoDrawer(true,CurrentQuestion)">查看代码</el-button>
                  </div> -->
                  <!-- <div :class="{'answer-analysis':true, ojtype: CurrentQuestion.type==9}">
                    <span class="analysis">试题解析:</span>
                    <el-button v-if="CurrentQuestion.type==9" style="margin-left:10px;" type="primary" size="small" round @click="handleProgrammingProblemDrawer(true,CurrentQuestion)">查看解析</el-button>
                    <template v-else>
                      <span class="analysis-content" v-if="CurrentQuestion.show_type === 1" v-html="CurrentQuestion.analysis"></span>
                      <span class="analysis-content" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="CurrentQuestion.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </span>
                    </template>
                  </div> -->

                  <!-- <div class="judgment">
                    <span class="label">本题得分:</span>

                    <el-input-number class="score" size="mini" v-model="final_score" :min="0" :max="CurrentQuestion.score" :precision="1" :step="0.1" label="本题得分"></el-input-number>

                    <el-button class="correct" size="mini" type="success" icon="el-icon-check" circle @click="checkStuExamQuestion('1')"></el-button>

                    <el-button class="wrong" size="mini" type="danger" icon="el-icon-close" circle @click="checkStuExamQuestion('2')"></el-button>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" style="position: fixed;">
          <div class="examinfo">
            <div class="exam-time">
              <i class="el-icon-alarm-clock"></i>
              <span class="time">{{
                hourString + ":" + minuteString + ":" + secondString
              }}</span>
            </div>

            <div class="stuinfo">
              <span class="name">姓名:<span style="margin-left: 10px">{{
                  $store.state.user.userInfo.stuUserInfo.realName
                }}</span></span>
              <span class="username">账号:<span style="margin-left: 10px">{{
                  $store.state.user.username
                }}</span></span>
            </div>
          </div>

          <div class="answer-card">
            <div v-if="form_state.onechoice">
              <span class="onechoice">单选题</span>
            </div>

            <div class="choice_item" v-if="form_state.onechoice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.onechoice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.multi_choice">
              <span>多选题</span>
            </div>

            <div class="choice_item" v-if="form_state.multi_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.multi_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.judge_choice">
              <span>判断题</span>
            </div>

            <div class="choice_item" v-if="form_state.judge_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.judge_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.space_choice">
              <span>填空题</span>
            </div>

            <div class="choice_item" v-if="form_state.space_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.space_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.blank_choice">
              <span>简答题</span>
            </div>

            <div class="choice_item" v-if="form_state.blank_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.blank_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.comprehensive_choice">
              <span>综合题</span>
            </div>

            <div class="choice_item" v-if="form_state.comprehensive_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.comprehensive_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>
            <div class="multichoice" v-if="form_state.ReadingProgram">
              <span>阅读程序题</span>
            </div>
            <div class="choice_item" v-if="form_state.ReadingProgram">
              <div v-for="(item, index) of form_state.ReadingProgramNumList" :key="index">
                <div style="padding:5px;">第{{ index + 1 }}题</div>

                <el-tag size="medium" class="tag" v-bind:class="{
                    tag_select: current_num == itemChild.index,
                    tag_hasdone: itemChild.stu_answer,
                  }" type="info" v-for="(itemChild, index) of item" :key="index" :label="itemChild.index + 1" @click.native="
                    ChooseQustion(itemChild.index, itemChild.type, itemChild)
                  ">{{ index + 1 }}</el-tag>
              </div>
            </div>
            <div class="multichoice" v-if="form_state.ImproveTheProgram">
              <span>完善程序题</span>
            </div>
            <div class="choice_item" v-if="form_state.ImproveTheProgram">
              <div v-for="(item, index) of form_state.ImproveTheProgramNumList" :key="index">
                <div style="padding:5px;">第{{ index + 1 }}题</div>
                <el-tag size="medium" class="tag" v-bind:class="{
                    tag_select: current_num == itemChild.index,
                    tag_hasdone: itemChild.stu_answer,
                  }" type="info" v-for="(itemChild, index) of item" :key="index" :label="itemChild.index + 1" @click.native="
                    ChooseQustion(itemChild.index, itemChild.type, itemChild)
                  ">{{ index + 1 }}</el-tag>
              </div>
            </div>
            <div class="multichoice" v-if="form_state.programmingProblem">
              <span>编程题</span>
            </div>
            <div class="choice_item" v-if="form_state.programmingProblem">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.programmingProblemList" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">
                {{ index + 1 }}
              </el-tag>
            </div>
          </div>

          <el-divider></el-divider>

          <div class="clearcontent">
            <el-button type="primary" @click="submitStuPaper" v-if="isShowButton">提交试卷</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-drawer :with-header="false" :title="
        hour
          ? hourString + ':' + minuteString + ':' + secondString
          : minuteString + ':' + secondString
      " :visible.sync="drawer" direction="ltr" :before-close="handleClose" size="100%">
      <iframe id="exam_iframe" width="100%" height="100%" class="course-view" :src="exam_url" v-if="exam_url"></iframe>

      <el-drawer :with-header="false" title="题目说明" direction="ltr" :append-to-body="true" :visible.sync="innerDrawer" size="50%">
        <div style="padding:20px;">
          <div style="font-size:20px;font-weight:500;">题目说明</div>
          <el-divider></el-divider>
          <div v-if="CurrentQuestion.show_type === 1" style="font-size:16px;" v-html="problem_desc" />
          <div v-else style="font-size:16px;">
            <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="problem_desc" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
          </div>
        </div>
      </el-drawer>
    </el-drawer>

    <div class="home-ai" ref="refAI" v-if="drawer&&CurrentQuestion.subject_id==1" @click="OpenDrawerJr">
      <img src="@/assets/image/stuUI/xiaoe.png" alt="" />
      <span>题目说明</span>
    </div>

    <el-drawer title="作答" :with-header="false" size="100%" :visible.sync="codeMirrorInfoShow" :direction="'ltr'">
      <div class="codemirror-info-container">
        <div class="codemirror-header">
          <div class="time">
            <i class="el-icon-alarm-clock" style="margin-right: 5px;"></i>
            <span>{{ hourString + ":" + minuteString + ":" + secondString }}</span>
          </div>
          <el-button icon="el-icon-back" style="backgroundColor:#4C95FC;border:none;color:#fff" @click="handleCodeMirrorInfoDrawer(false)">返回试卷</el-button>
        </div>
        <codeMirrorInfoComponent :canSubmit="true" v-if="CurrentQuestion.ojProblemInfo && codeMirrorInfoShow" :CurrentQuestion="CurrentQuestion.ojProblemInfo" :stuExamQuestionId="String(stuExamQuestionInfoId)" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getStuExamQuestionList,
  checkSingleQuestion,
  getStuQuestionAnswer,
  submitStuPaper,
} from "@/api/educational";

import Axios from "axios";

import Prism from "prismjs";
import "prismjs/themes/prism-twilight.css"; // you can change

import getcode from "@/config/getCodesStyle";

import codeMirrorInfoComponent from '@/components/codeMirrorInfo.vue'

export default {
  name: "new-exam",
  components: {
    codeMirrorInfoComponent
  },
  data() {
    return {
      problemItem: null,
      analyzeList: [],
      analyzeItem: null,
      analyzePage: {
        page_no: 1,
        page_size: 10,
        total: 0
      },
      codeMirrorInfoItem: null,
      codeMirrorInfoShow: false,
      stuExamQuestionInfoId: '',
      isShowButton: true,
      timeNew: "",
      disabled1: false,
      //综合题作答
      drawer: false,
      innerDrawer: false,

      title: "",
      exam_id: "",
      model: "",
      radio_num: "1", //题号
      radio: "",
      auto_change: true,
      show_answer: true,
      form: {
        question_a: "print('Hello World')",
        question_b: "",
        question_c: "",
        question_d: "",
        resolution: "这个问题,应该这样回答？",
      },
      paperQuestionList: [], //题目列表
      //题库试题状态
      form_state: {
        ReadingProgramNumList: [],
        ReadingProgramNum: 0,
        ReadingProgram: false,
        ReadingProgram_score: 0,

        ImproveTheProgramNum: 0,
        ImproveTheProgramNumList: [],
        ImproveTheProgram: false,
        ImproveTheProgram_score: 0,
        // 编程题
        programmingProblemShow: false,
        programmingProblemNum: 0,
        programmingProblemList: [],
        programmingProblem: false,
        programmingProblem_score: 0,


        onechoice: false,
        onechoice_num: 0,
        onechoice_score: 0,
        onechoice_arr: [],
        onechoice_option: "",

        multi_choice: false,
        multi_choice_num: 0,
        multi_choice_score: 0,
        multi_choice_arr: [],
        judge_choice: false,
        judge_choice_num: 0,
        judge_choice_score: 0,
        judge_choice_arr: [],
        space_choice: false,
        space_choice_num: 0,
        space_choice_score: 0,
        space_choice_arr: [],
        blank_choice: false,
        blank_choice_num: 0,
        blank_choice_score: 0,
        blank_choice_arr: [],
        comprehensive_choice: false,
        comprehensive_choice_num: 0,
        comprehensive_choice_score: 0,
        comprehensive_choice_arr: [],
      },
      //倒计时功能
      hour: "",
      minute: "",
      second: "",
      promiseTimer: "",
      remainTime: 0,
      CurrentQuestion: {
        answers: [false, false, false, false],
        blank_answer: "", //简答题
      }, //当前试题
      current_num: 0, //当前试题编号
      exam: {}, //考试信息
      paper: {}, //试卷信息
      exam_url: "", //创作地址
      project_url: "", //综合题创作地址

      //上一题、下一题
      prebtn: false,
      nextbtn: false,

      //锁控制
      check_stated: true,

      //题目说明
      problem_desc: "",

      FullScreen_state: false,
    };
  },

  computed: {
    hourString() {
      return this.formatNum(this.hour);
    },
    minuteString() {
      return this.formatNum(this.minute);
    },
    secondString() {
      return this.formatNum(this.second);
    },
  },

  watch: {
    timeNew(val) {
      console.log(val, 121254);
    },
    drawer() {
      console.log(this.drawer);
      if (!this.drawer) {
        this.getStuQuestionAnswer();
      }
    },
  },

  mounted() {
    this.title = this.$route.query.title;
    this.exam_id = this.$route.query.id;
    this.getStuExamQuestionList();

    window.addEventListener("message", this.receiveDataFromIframe);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveDataFromIframe);
  },

  methods: {
    receiveDataFromIframe(state) {
      // 在这里处理从 iframe 内部传递的参数
      if (state.data == "enter") {
        this.FullScreen_state = true;
      } else if (state.data == "exit") {
        this.FullScreen_state = false;
      } else if (state.data == "closejr") {
        this.drawer = false;
      }
    },

    //根据code值是否相同，拆分题目
    groupByCode(arr) {
      return arr.reduce(function (result, item) {
        var i;
        for (i = 0; i < result.length; i++) {
          if (result[i][0].code_other === item.code_other) {
            result[i].push(item);
            return result;
          }
        }
        result.push([item]);
        return result;
      }, []);
    },

    BeautifyCode() {
      this.$nextTick(() => {
        console.log("元素已经渲染完毕");

        // 查找组件根元素下的<pre>元素
        const preElement = this.$el.querySelector(".hljs");
        const preElementPy = this.$el.querySelector(".language-python");
        const preElementCpp = this.$el.querySelector(".language-cpp");
        const preElementPyMd = this.$el.querySelector(".lang-python");
        const preElementCppMd = this.$el.querySelector(".lang-cpp");

        if (
          preElement ||
          preElementPy ||
          preElementCpp ||
          preElementPyMd ||
          preElementCppMd
        ) {
          // 页面包含<pre>元素
          console.log("页面包含<hljs>元素");
        } else {
          // 页面不包含<pre>元素
          console.log("页面不包含<hljs>元素");
          return;
        }

        let timeoutId;
        const intervalId = setInterval(() => {
          const numberElement = document.querySelector(".line-num-box");
          const lineNumbersRowsElement = document.querySelector(
            ".line-numbers-rows"
          );

          if (numberElement || lineNumbersRowsElement) {
            console.log("关闭定时器");
            clearInterval(intervalId);
            clearTimeout(timeoutId);
          } else {
            console.log("试图渲染行号");

            if (this.paperQuestionList[0].show_type == 2) {
              getcode();
            } else {
              Prism.highlightAll();
            }
          }
        }, 100);

        timeoutId = setTimeout(() => {
          console.log("超时，取消定时器");
          clearInterval(intervalId);
        }, 10000); // 10秒后取消定时器
      });
    },

    goback() {
      if (this.isShowButton === true) {
        console.log("离开考试");

        this.$confirm("确定提交试卷并离开吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          submitStuPaper({
            examId: this.exam_id,
            lastTime:
              this.remainTime -
                this.hour * 3600 -
                this.minute * 60 -
                this.second
                ? this.remainTime -
                this.hour * 3600 -
                this.minute * 60 -
                this.second
                : this.remainTime,
          }).then((res) => {
            console.log("提交试卷");
            console.log(res);
            clearInterval(this.promiseTimer);
            if (res.is_update) {
              this.$message.success("交卷成功");
              this.$router.push({
                name: "exam-list",
              });
            }
          });
        });
      } else {
        this.$confirm("确定提交试卷并离开吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$message.success("交卷成功");
          this.$router.push({
            name: "exam-list",
          });
        });
      }
    },

    CloseDrawer() {
      this.innerDrawer = false;
      this.$confirm("确定返回试卷吗? 记得保存作答哦！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.drawer = false;
        this.exam_url = "";
      });
    },

    OpenDrawer() {
      this.innerDrawer = true;
      console.log("题目说明");
    },

    OpenDrawerJr() {
      this.innerDrawer = true;
    },

    ReadPyCode(url, callback) {
      Axios({
        method: "get",
        url: url,
        responseType: "text",
      }).then((res) => {
        callback(res.data);
      });
    },

    checkAddType() {
      console.log("强制刷新状态");
      this.$forceUpdate();
    },

    getStuExamQuestionList() {
      getStuExamQuestionList({
        examId: this.exam_id,
      }).then(
        (res) => {
          console.log("获得考试题目");
          console.log(res);
          this.paperQuestionList = res.questionList;
          this.exam = res.exam;
          this.paper = res.paper;

          console.log("考试题目列表");
          console.log(this.paperQuestionList);

          this.remainTime = res.exam.lasttime;
          let start_time = res.stu_start_time;
          let systeamDate = res.systeamDate;
          let staytimeGap =
            new Date(systeamDate).getTime() - new Date(start_time).getTime();
          console.log(new Date(systeamDate).getTime(), 786152);
          console.log(new Date(start_time).getTime(), 786152);

          let nowTimeMiao = Math.floor(this.remainTime - staytimeGap / 1000);
          console.log(this.remainTime - staytimeGap, 1213323);
          console.log(
            new Date(systeamDate).getTime() - new Date(start_time).getTime(),
            1213323
          );
          console.log(
            Math.floor(this.remainTime - staytimeGap / 1000),
            1213323
          );
          console.log(start_time, 1213323);
          this.hour = Math.floor((nowTimeMiao / 3600) % 24);
          this.minute = Math.floor((nowTimeMiao / 60) % 60);
          this.second = Math.floor(nowTimeMiao % 60);
          this.countDowm();
          //时间差结束
          this.CurrentQuestion = this.paperQuestionList[this.current_num || 0];
          this.form_state.onechoice_arr = [];
          this.form_state.onechoice_num = 0;
          this.form_state.multi_choice_arr = [];
          this.form_state.multi_choice_num = 0;
          this.form_state.judge_choice_arr = [];
          this.form_state.judge_choice_num = 0;
          this.form_state.space_choice_arr = [];
          this.form_state.space_choice_num = 0;
          this.form_state.blank_choice_arr = [];
          this.form_state.blank_choice_num = 0;
          this.form_state.comprehensive_choice_arr = [];
          this.form_state.comprehensive_choice_num = 0;

          this.form_state.ReadingProgramNumList = [];
          this.form_state.ReadingProgramNum = 0;

          this.form_state.ImproveTheProgramNumList = [];
          this.form_state.ImproveTheProgramNum = 0;

          this.form_state.programmingProblemList = []
          this.form_state.programmingProblemNum = 0

          for (let k = 0; k < this.paperQuestionList.length; k++) {
            this.paperQuestionList[k].index = k;

            if (this.paperQuestionList[k].stuExamQuestionInfo) {
              this.paperQuestionList[k].stu_answer = this.paperQuestionList[
                k
              ].stuExamQuestionInfo.answer; //记录学生答案
              this.paperQuestionList[
                k
              ].stuExamQuestionId = this.paperQuestionList[
                k
              ].stuExamQuestionInfo.id;
            } else {
              this.paperQuestionList[k].stu_answer = "";
              this.paperQuestionList[k].stuExamQuestionId = "";
            }

            this.paperQuestionList[k].answers = [false, false, false, false]; //多选题

            if (this.paperQuestionList[k].type == "1") {
              console.log("包含单选题");
              this.form_state.onechoice = true;
              this.form_state.onechoice_num =
                parseInt(this.form_state.onechoice_num) + 1;
              this.form_state.onechoice_arr.push(this.paperQuestionList[k]);
            } else if (this.paperQuestionList[k].type == "2") {
              console.log("包含多选题");
              this.form_state.multi_choice = true;
              this.form_state.multi_choice_num =
                parseInt(this.form_state.multi_choice_num) + 1;
              this.form_state.multi_choice_arr.push(this.paperQuestionList[k]);
            } else if (this.paperQuestionList[k].type == "3") {
              console.log("包含判断题");
              this.form_state.judge_choice = true;
              this.form_state.judge_choice_num =
                parseInt(this.form_state.judge_choice_num) + 1;
              this.form_state.judge_choice_arr.push(this.paperQuestionList[k]);
            } else if (this.paperQuestionList[k].type == "4") {
              console.log("包含填空题");
              this.form_state.space_choice = true;
              console.log(this.paperQuestionList[k], 123465);
              this.form_state.space_choice_num =
                parseInt(this.form_state.space_choice_num) + 1;
              console.log(this.form_state.space_choice_num, 123465);
              this.form_state.space_choice_arr.push(this.paperQuestionList[k]);
              this.CurrentQuestion.space_answers = new Array();
              console.log(this.CurrentQuestion.tiankong_num, 123465);
            } else if (this.paperQuestionList[k].type == "5") {
              console.log("包含简答题");
              this.form_state.blank_choice = true;
              this.form_state.blank_choice_num =
                parseInt(this.form_state.blank_choice_num) + 1;
              this.form_state.blank_choice_arr.push(this.paperQuestionList[k]);
            } else if (this.paperQuestionList[k].type == "6") {
              console.log("包含综合题");
              this.form_state.comprehensive_choice = true;
              this.form_state.comprehensive_choice_num =
                parseInt(this.form_state.comprehensive_choice_num) + 1;
              this.form_state.comprehensive_choice_arr.push(
                this.paperQuestionList[k]
              );
            } else if (this.paperQuestionList[k].type == "7") {
              this.form_state.ReadingProgram = true;
              this.form_state.ReadingProgramNum =
                parseInt(this.form_state.ReadingProgramNum) + 1;
              this.form_state.ReadingProgramNumList.push(
                this.paperQuestionList[k]
              );
            } else if (this.paperQuestionList[k].type == "8") {
              this.form_state.ImproveTheProgram = true;
              this.form_state.ImproveTheProgramNum =
                parseInt(this.form_state.ImproveTheProgramNum) + 1;
              this.form_state.ImproveTheProgramNumList.push(
                this.paperQuestionList[k]
              );
            } else if (this.paperQuestionList[k].type == '9') {
              this.form_state.programmingProblem = true
              this.form_state.programmingProblemNum =
                parseInt(this.form_state.programmingProblemNum) + 1
              this.form_state.programmingProblemList.push(
                this.paperQuestionList[k]
              )
            }
          }

          console.log("试题列表");
          console.log(this.paperQuestionList);

          console.log("阅读程序题列表");
          console.log(this.form_state.ReadingProgramNumList);

          console.log("分类后的阅读程序题");
          this.form_state.ReadingProgramNumList = this.groupByCode(
            this.form_state.ReadingProgramNumList
          );
          console.log(this.form_state.ReadingProgramNumList);

          console.log("完善程序题列表");
          console.log(this.form_state.ImproveTheProgramNumList);

          console.log("分类后的完善程序题");
          this.form_state.ImproveTheProgramNumList = this.groupByCode(
            this.form_state.ImproveTheProgramNumList
          );
          console.log(this.form_state.ImproveTheProgramNumList);

          this.BeautifyCode();
        },
        (err) => {
          console.log("err", err);
          this.isShowButton = false;
        }
      );
    },

    PreQuestion() {
      console.log("上一题");

      this.ChooseQustion(
        this.current_num - 1,
        this.paperQuestionList[this.current_num - 1].type
      );

      if (this.current_num == 0) {
        this.prebtn = true;
        this.nextbtn = false;
      }

      if (this.current_num < this.paperQuestionList.length - 1) {
        this.nextbtn = false;
      }
    },

    NextQuestion() {
      console.log("下一题");
      this.ChooseQustion(
        this.current_num + 1,
        this.paperQuestionList[this.current_num + 1].type
      );

      if (this.current_num > 0) {
        this.prebtn = false;
      }

      if (this.current_num == this.paperQuestionList.length - 1) {
        this.nextbtn = true;
      }
    },

    //点击答题卡
    ChooseQustion(ref, type) {
      console.log("点击答题卡");
      console.log(ref);
      console.log("题目类型");
      console.log(type);

      this.CurrentQuestion = this.paperQuestionList[ref];
      this.current_num = ref;

      console.log("当前试题");
      console.log(this.CurrentQuestion);

      if (this.CurrentQuestion.type == 2) {
        console.log("当前为多选题");

        if (this.CurrentQuestion.stu_answer.indexOf("A") !== -1) {
          this.CurrentQuestion.answers[0] = true;
        }

        if (this.CurrentQuestion.stu_answer.indexOf("B") !== -1) {
          this.CurrentQuestion.answers[1] = true;
        }

        if (this.CurrentQuestion.stu_answer.indexOf("C") !== -1) {
          this.CurrentQuestion.answers[2] = true;
        }

        if (this.CurrentQuestion.stu_answer.indexOf("D") !== -1) {
          this.CurrentQuestion.answers[3] = true;
        }
      } else if (this.CurrentQuestion.type == 4) {
        console.log("该题为填空题");

        this.CurrentQuestion.space_answers = new Array();
        for (let k = 0; k < this.CurrentQuestion.tiankong_num; k++) {
          if (this.CurrentQuestion.stu_answer) {
            this.CurrentQuestion.space_answers[
              k
            ] = this.CurrentQuestion.stu_answer.split("┅")[k];
          } else {
            this.CurrentQuestion.space_answers[k] = "";
          }
        }
      } else if (this.CurrentQuestion.type == 5) {
        console.log("该题型为简单题");
        this.CurrentQuestion.blank_answer = this.CurrentQuestion.stu_answer;
      } else if (this.CurrentQuestion.type == 6) {
        console.log("该题型为综合题");
        console.log(JSON.parse(this.CurrentQuestion.options));
      }

      this.BeautifyCode();
    },

    //同步判题
    checkSingleQuestion(answer, type, ev) {
      if (ev.target.tagName === "INPUT") return;

      // if (this.check_stated) {
      //   console.log('可点')
      //   this.check_stated = false;
      // }
      // else {
      //   console.log('点击过快,返回')
      //   return;
      // }

      if (type == "1" || type == "2") {
        console.log("单选题或判断题");

        if (
          this.paperQuestionList[this.CurrentQuestion.index].stuExamQuestionId
        ) {
          console.log("学生已做过该题");

          checkSingleQuestion({
            examId: this.exam_id,
            questionId: this.CurrentQuestion.id,
            questionScore: this.CurrentQuestion.score,
            answer: answer,
            stuExamQuestionId: this.paperQuestionList[
              this.CurrentQuestion.index
            ].stuExamQuestionId,
          }).then((res) => {
            console.log("学生更新作答");
            console.log(res);
            this.disabled1 = true;
            setTimeout(() => {
              this.disabled1 = false;
            }, 500);
            this.check_stated = true;
          });
        } else {
          console.log("学生没有过该题");
          checkSingleQuestion({
            examId: this.exam_id,
            questionId: this.CurrentQuestion.id,
            questionScore: this.CurrentQuestion.score,
            answer: answer,
          }).then((res) => {
            console.log("学生没作答过");
            console.log(res);
            this.disabled1 = true;
            setTimeout(() => {
              this.disabled1 = false;
            }, 500);
            this.check_stated = true;

            if (res.stuExamQuestionId) {
              this.paperQuestionList[
                this.CurrentQuestion.index
              ].stuExamQuestionId = res.stuExamQuestionId;
            }
          });
        }
      }
    },

    SubmitAnswer() {
      console.log("提交多选题答案");
      console.log(this.CurrentQuestion);

      // if (this.check_stated) {
      //   console.log('可点')
      //   this.check_stated = false;
      // }
      // else {
      //   console.log('点击过快,返回')
      //   return;
      // }

      var has_answer = false;
      var answer = [];
      for (let k = 0; k < this.CurrentQuestion.answers.length; k++) {
        if (this.CurrentQuestion.answers[k]) {
          has_answer = true;
          if (k == 0) {
            answer.push("A");
          } else if (k == 1) {
            answer.push("B");
          } else if (k == 2) {
            answer.push("C");
          } else if (k == 3) {
            answer.push("D");
          }
        }
      }
      if (!has_answer) {
        this.$message.warning("请选择答案");
        return;
      }

      if (
        this.paperQuestionList[this.CurrentQuestion.index].stuExamQuestionId
      ) {
        console.log("学生已做过该题");

        checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
          answer: answer.join(","),
          stuExamQuestionId: this.paperQuestionList[this.CurrentQuestion.index]
            .stuExamQuestionId,
        }).then((res) => {
          console.log("学生更新作答");
          console.log(res);
          this.check_stated = true;
          this.disabled1 = true;
          setTimeout(() => {
            this.disabled1 = false;
          }, 500);
          this.paperQuestionList[
            this.CurrentQuestion.index
          ].stu_answer = answer.join(",");
        });
      } else {
        console.log("学生没有过该题");
        checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
          answer: answer.join(","),
        }).then((res) => {
          console.log("学生没作答过");
          console.log(res);
          this.disabled1 = true;
          setTimeout(() => {
            this.disabled1 = false;
          }, 500);
          this.check_stated = true;
          if (res.stuExamQuestionId) {
            this.paperQuestionList[
              this.CurrentQuestion.index
            ].stuExamQuestionId = res.stuExamQuestionId;

            this.paperQuestionList[
              this.CurrentQuestion.index
            ].stu_answer = answer.join(",");
          }
        });
      }
    },

    SubmitSpaceAnswer() {
      console.log("填空题判题");
      console.log(this.CurrentQuestion.space_answers);

      var has_answer = false;

      for (let k = 0; k < this.CurrentQuestion.space_answers.length; k++) {
        if (this.CurrentQuestion.space_answers[k]) {
          has_answer = true;
        }
      }

      if (!has_answer) {
        this.$message.warning("请选择输入作答内容");
        return;
      }

      if (
        this.paperQuestionList[this.CurrentQuestion.index].stuExamQuestionId
      ) {
        console.log("学生已做过该题");

        checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
          answer: this.CurrentQuestion.space_answers.join("┅"),
          stuExamQuestionId: this.paperQuestionList[this.CurrentQuestion.index]
            .stuExamQuestionId,
        }).then((res) => {
          console.log("学生更新作答");
          console.log(res);

          this.paperQuestionList[
            this.CurrentQuestion.index
          ].stu_answer = this.CurrentQuestion.space_answers.join("┅");
        });
      } else {
        console.log("学生没有过该题");
        checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
          answer: this.CurrentQuestion.space_answers.join("┅"),
        }).then((res) => {
          console.log("学生没作答过");
          console.log(res);

          if (res.stuExamQuestionId) {
            this.paperQuestionList[
              this.CurrentQuestion.index
            ].stuExamQuestionId = res.stuExamQuestionId;

            this.paperQuestionList[
              this.CurrentQuestion.index
            ].stu_answer = this.CurrentQuestion.space_answers.join("┅");
          }
        });
      }
    },

    SubmitBlankAnswer() {
      console.log("简答题判题");
      console.log(this.CurrentQuestion.blank_answer);
      if (!this.CurrentQuestion.blank_answer) {
        this.$message.warning("请输入作答内容");
        return;
      }

      if (
        this.paperQuestionList[this.CurrentQuestion.index].stuExamQuestionId
      ) {
        console.log("学生已做过该题");

        checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
          answer: this.CurrentQuestion.blank_answer,
          stuExamQuestionId: this.paperQuestionList[this.CurrentQuestion.index]
            .stuExamQuestionId,
        }).then((res) => {
          console.log("学生更新作答");
          console.log(res);

          this.paperQuestionList[
            this.CurrentQuestion.index
          ].stu_answer = this.CurrentQuestion.blank_answer;
        });
      } else {
        console.log("学生没有过该题");
        checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
          answer: this.CurrentQuestion.blank_answer,
        }).then((res) => {
          console.log("学生没作答过");
          console.log(res);

          if (res.stuExamQuestionId) {
            this.paperQuestionList[
              this.CurrentQuestion.index
            ].stuExamQuestionId = res.stuExamQuestionId;

            this.paperQuestionList[
              this.CurrentQuestion.index
            ].stu_answer = this.CurrentQuestion.blank_answer;
          }
        });
      }
    },

    GoCreate() {
      console.log("去创作");
      console.log(this.CurrentQuestion, 123564);
      console.log(JSON.parse(this.CurrentQuestion.options)[0].content);
      if (this.CurrentQuestion.subject_id == 1) {
        console.log("Jrcode考试");

        if (this.CurrentQuestion.show_type === 1) {
          this.problem_desc = this.CurrentQuestion.title;
        } else {
          this.problem_desc = this.CurrentQuestion.title_md;
        }

        if (this.CurrentQuestion.stuExamQuestionId) {
          this.project_url = this.CurrentQuestion.stu_answer.split(",")[2];

          console.log("答案");
          console.log(this.CurrentQuestion.stu_answer.split(",")[0]);

          this.exam_url =
            "/jrcode/practice.html?mode=edit&role=stu&type=4&filepath=" +
            this.project_url +
            "&examId=" +
            this.exam_id +
            "&questionId=" +
            this.CurrentQuestion.id +
            "&project_url=" +
            this.project_url +
            "&project_png=" +
            this.CurrentQuestion.stu_answer.split(",")[1] +
            "&project_title=" +
            this.CurrentQuestion.stu_answer.split(",")[0] +
            "&stuExamQuestionId=" +
            this.CurrentQuestion.stuExamQuestionId;
        } else {
          this.exam_url =
            "/jrcode/practice.html?mode=edit&role=stu&type=4&filepath=https://wgdxoss.oss-cn-zhangjiakou.aliyuncs.com/practice/project.sjr" +
            "&examId=" +
            this.exam_id +
            "&questionId=" +
            this.CurrentQuestion.id;
        }

        console.log("Jrcode综合题地址");
        console.log(this.exam_url);

        this.drawer = true;
      } else if (this.CurrentQuestion.subject_id == 2) {
        if (this.CurrentQuestion.show_type === 1) {
          this.problem_desc = this.CurrentQuestion.title;
        } else {
          this.problem_desc = this.CurrentQuestion.title_md;
        }
        if (this.CurrentQuestion.stuExamQuestionId) {
          this.project_url = this.CurrentQuestion.stu_answer.split(",")[2];

          console.log("答案");
          console.log(this.CurrentQuestion.stu_answer.split(",")[0]);
          this.exam_url =
            "/scratch/exam.html?examId=" +
            this.exam_id +
            "&questionId=" +
            this.CurrentQuestion.id +
            "&project_url=" +
            this.project_url +
            "&project_png=" +
            this.CurrentQuestion.stu_answer.split(",")[1] +
            "&project_title=" +
            this.CurrentQuestion.stu_answer.split(",")[0] +
            "&stuExamQuestionId=" +
            this.CurrentQuestion.stuExamQuestionId;
        } else {
          console.log(123456, 123456);
          console.log(this.CurrentQuestion, 123456);
          if (this.CurrentQuestion.educational_institution_id === null) {
            //为了弥补题库编辑时候的存储位置BUG临时修改
            if (JSON.parse(this.CurrentQuestion.options)[0].content) {
              this.project_url = JSON.parse(
                this.CurrentQuestion.options
              )[0].content;
            } else {
              this.project_url = JSON.parse(this.CurrentQuestion.answer)[0].url;
            }
          } else {
            this.project_url = JSON.parse(
              this.CurrentQuestion.options
            )[0].content;
          }

          this.exam_url =
            "/scratch/exam.html?examId=" +
            this.exam_id +
            "&questionId=" +
            this.CurrentQuestion.id +
            "&project_url=" +
            this.project_url +
            "&project_title=考试模板";
        }

        console.log("综合题地址");
        console.log(this.exam_url);

        this.drawer = true;
      } else if (this.CurrentQuestion.subject_id == 3) {
        console.log("python作答");

        if (this.CurrentQuestion.show_type === 1) {
          this.problem_desc = this.CurrentQuestion.title;
        } else {
          this.problem_desc = this.CurrentQuestion.title_md;
        }

        if (this.CurrentQuestion.stu_answer) {
          sessionStorage.setItem(
            "py_exam_code",
            JSON.parse(this.CurrentQuestion.stu_answer)[0].code
          );

          this.exam_url =
            "/python/exam_v2?type=5&operate=1&examId=" +
            this.exam_id +
            "&questionId=" +
            this.CurrentQuestion.id +
            "&stuExamQuestionId=" +
            this.CurrentQuestion.stuExamQuestionId;
          this.drawer = true;
        } else {
          // var url = JSON.parse(this.CurrentQuestion.answer)[0].url;
          var url = "";
          if (this.CurrentQuestion.educational_institution_id === null) {
            console.log("模板地址");
            console.log(JSON.parse(this.CurrentQuestion.options));
            console.log(JSON.parse(this.CurrentQuestion.options)[0].content);

            if (JSON.parse(this.CurrentQuestion.options)[0].content) {
              url = JSON.parse(this.CurrentQuestion.options)[0].content;
            } else {
              url = JSON.parse(this.CurrentQuestion.answer)[0].url;
            }
          } else {
            url = JSON.parse(this.CurrentQuestion.options)[0].content;
          }

          this.ReadPyCode(url, (res) => {
            sessionStorage.setItem("py_exam_code", res);

            this.exam_url =
              "/python/exam_v2?type=5&operate=1&examId=" +
              this.exam_id +
              "&questionId=" +
              this.CurrentQuestion.id +
              "&stuExamQuestionId=" +
              this.CurrentQuestion.stuExamQuestionId;
            this.drawer = true;
          });
        }
      }
    },

    GoReCreate() {
      this.project_url = this.CurrentQuestion.stu_answer.split(",")[2];

      console.log("答案");
      console.log(this.CurrentQuestion.stu_answer.split(",")[0]);

      this.exam_url =
        "/scratch/exam.html?examId=" +
        this.exam_id +
        "&questionId=" +
        this.CurrentQuestion.id +
        "&project_url=" +
        this.project_url +
        "&project_png=" +
        this.CurrentQuestion.stu_answer.split(",")[1] +
        "&project_title=" +
        this.CurrentQuestion.stu_answer.split(",")[0] +
        "&stuExamQuestionId=" +
        this.CurrentQuestion.stuExamQuestionId;
      this.drawer = true;
    },

    getStuQuestionAnswer() {
      getStuQuestionAnswer({
        examId: this.exam_id,
        questionId: this.CurrentQuestion.id,
      }).then((res) => {
        console.log("综合题答案");
        console.log(res);
        this.paperQuestionList[this.CurrentQuestion.index].stu_answer =
          res.stuExamQuestion.answer;

        this.CurrentQuestion.stu_answer = res.stuExamQuestion.answer;
        this.CurrentQuestion.stuExamQuestionId = res.stuExamQuestion.id;
      });
    },

    submitStuPaper() {
      console.log("总时间");
      console.log(this.remainTime);
      console.log("剩余时间");
      console.log(this.hour * 3600 + this.minute * 60 + this.second);

      this.$confirm("确定提交试卷吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        submitStuPaper({
          examId: this.exam_id,
          lastTime:
            this.remainTime - this.hour * 3600 - this.minute * 60 - this.second
              ? this.remainTime -
              this.hour * 3600 -
              this.minute * 60 -
              this.second
              : this.remainTime,

          // lastTime:
          //   this.remainTime - this.hour * 3600 - this.minute * 60 - this.second,
        }).then((res) => {
          console.log("提交试卷");
          console.log(res);
          clearInterval(this.promiseTimer);
          if (res.is_update) {
            this.$message.success("交卷成功");
            this.$router.push({
              name: "exam-list",
            });
          }
        });
      });
    },

    handleClose(done) {
      done();
    },

    countDowm() {
      console.log(123456, 11111);
      var self = this;

      clearInterval(this.promiseTimer);
      this.promiseTimer = setInterval(function () {
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59;
            self.minute -= 1;
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0;
            self.$emit("countDowmEnd", true);
            clearInterval(self.promiseTimer);
          } else {
            self.second -= 1;
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59;
            self.minute -= 1;
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1;
            self.minute = 59;
            self.second = 59;
          } else {
            self.second -= 1;
          }
        }

        // console.log("剩余时间");
        var remain = self.hour * 3600 + self.minute * 60 + self.second;
        // console.log(remain);

        if (remain == 0) {
          clearInterval(self.promiseTimer);
          submitStuPaper({
            examId: self.exam_id,
            lastTime: self.exam.lasttime,
          }).then((res) => {
            console.log("提交试卷");
            console.log(res);
            if (res.is_update) {
              self.$message.success("交卷成功");
              self.$router.push({
                name: "exam-list",
              });
            }
          });
        }
      }, 1000);
    },
    formatNum(num) {
      return num < 10 ? "0" + num : "" + num;
    },
    // 查看学生OJ答案
    async handleCodeMirrorInfoDrawer(show) {
      if (show) {
        const res = await checkSingleQuestion({
          examId: this.exam_id,
          questionId: this.CurrentQuestion.id,
          questionScore: this.CurrentQuestion.score,
        })
        if (res.stuExamQuestionId) {
          this.stuExamQuestionInfoId = res.stuExamQuestionId
        }
      } else {
        this.getStuExamQuestionList()
      }
      if (this.stuExamQuestionInfoId) {
        this.codeMirrorInfoShow = show
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .hljs {
  background: transparent;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}
.question-body {
  width: 100%;
  overflow: hidden;
  strong {
    display: block;
    padding-bottom: 10px;
  }
  /deep/ .v-show-content {
    padding: 0;
  }
}

.wrapper-exam {
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;

  .question {
    margin-top: 30px;

    .question-wrapper {
      padding: 5px;
      min-height: calc(100vh - 160px);
      overflow-y: scroll;
      overflow-x: hidden;

      .exam_wrapper {
        text-align: center;

        .exam_title {
          font-size: 20px;
          font-weight: bold;
        }

        .exam_set {
          font-size: 16px;

          .exam_label {
            margin-left: 20px;
          }

          .exam_text {
            margin-left: 20px;
          }
        }
      }

      .question-header {
        .question-label {
          line-height: 30px;
          font-size: 16px;
        }

        .question-type {
          margin-left: 10px;
        }
      }

      .question-btn {
        float: right;
      }

      .question-content {
        .question-info {
          display: flex;

          .question-sort {
          }

          .question-title {
            width: calc(100% - 103px);
            margin-left: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: bold;
          }

          .question-score {
            margin-left: 20px;
            margin-bottom: 20px;
            font-size: 16px;
          }
        }

        .answer-otions {
          .option-wrapper {
            float: left;
            width: 100%;
            margin-bottom: 20px;
            font-size: 16px;

            .option-tab {
              float: left;
              margin-left: 10px;
              font-weight: bold;
            }

            .option-input {
              float: left;
              // width: 500px;
              width: calc(100% - 119px);
              margin-left: 10px;
              border-radius: 5px;
            }

            .el-icon-edit {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }

        .gocreate {
          text-align: left;

          .image {
            width: 240px;
            height: 180px;
            cursor: pointer;
          }
        }
      }

      .answer-check {
        .correct_label {
          font-weight: bold;
        }

        .correct_answer {
          color: orange;
          font-weight: bold;
          margin-left: 10px;
        }

        .myanswer_label {
          font-weight: bold;
          margin-left: 20px;
        }

        .myanswer {
          color: orange;
          font-weight: bold;
          margin-left: 10px;
        }

        .wrong {
          margin-left: 20px;
        }

        .correct {
          margin-left: 20px;
        }
      }

      .resolution {
        margin-top: 20px;

        .recolution-title {
          font-weight: bold;
          color: green;
        }

        .resolution-content {
          margin-top: 20px;
        }
      }
    }

    .examinfo {
      width: 100%;
      height: 120px;

      .exam-time {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 30px;

        .time {
          margin-left: 10px;
        }
      }

      .stuinfo {
        width: 100%;
        height: 40px;

        line-height: 40px;
        font-size: 16px;

        .name {
        }

        .username {
          margin-left: 10px;
        }
      }
    }

    .answer-card {
      margin-top: 10px;
      padding: 5px;
      height: calc(100vh - 400px);
      overflow-y: auto;

      .choice_item {
        margin-top: 20px;

        .tag {
          width: 50px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          background: white;
          font-size: 16px;
          margin: 2px;
          text-align: center;
        }

        .tag_select {
          width: 50px;
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          margin: 2px;
          text-align: center;

          cursor: pointer;
          background: rgb(236, 230, 230);
        }

        .tag_hasdone {
          width: 50px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          background: #409eff;
          color: white;
          font-size: 16px;
          margin: 2px;
          text-align: center;
        }

        .choice_item_label {
          margin-bottom: 10px;
        }

        .choice_num {
        }
      }

      .onechoice {
        font-weight: bold;
      }

      .multichoice {
        font-weight: bold;
        margin-top: 10px;
      }
    }

    .el-icon-success {
      color: green;
    }

    .el-icon-error {
      color: red;
      margin-left: 20px;
    }

    .el-icon-s-data {
      color: orange;
      margin-left: 20px;
    }

    .answerinfo {
      margin-top: 20px;

      .answerinfo1 {
        margin-left: 5px;
        font-weight: bold;
      }

      .answerinfo1-1 {
        margin-left: 10px;
      }

      .answerinfo2 {
        margin-left: 5px;
        font-weight: bold;
      }

      .answerinfo2-1 {
        margin-left: 10px;
      }

      .answerinfo3 {
        margin-left: 5px;
        font-weight: bold;
      }

      .answerinfo3-1 {
        margin-left: 10px;
      }
    }

    .settings {
      font-weight: bold;
      color: #529dfe;
      margin-left: 5px;
    }

    .auto_change {
      margin-top: 15px;
      padding: 5px;
    }

    .show_answer {
      margin-top: 10px;
      padding: 5px;
    }

    .clearcontent {
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 5px;
      text-align: center;
    }
  }

  .home-ai {
    position: fixed;
    bottom: 15px;
    right: 20px;
    z-index: 10000;
    cursor: pointer;
    img {
      width: 70px;
    }
    span {
      position: absolute;
      left: 50%;
      bottom: -5px;
      transform: translateX(-50%);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 83px;
      height: 26px;
      background: #1778ff;
      border-radius: 5px;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
    }
  }
}
.el-drawer__body {
  .analyze-content,
  .codemirror-info-container {
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background: #f1f1f1;
      /*可以设置轨道颜色*/
      padding-right: 2px;
    }

    /*滚动条*/
    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #f1f7fe;
    .analyze-header,
    .codemirror-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 15px 30px;
      background-color: #1878ff;
      .time {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        padding: 0 10px;
        margin-right: 20px;
        background-color: rgb(76, 149, 252);
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
      }
    }
    .analyze-body {
      display: flex;
      height: 100%;
      padding: 20px;
      overflow: hidden;
      .analyze-left {
        width: 50%;
        padding: 15px;
        margin-right: 10px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 5px;
        .analyze-left-item {
          padding: 15px;
          border-bottom: 1px solid #f0f3f9;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.25s;
          &:hover {
            background-color: #efefef;
          }
          &.active {
            .title {
              strong {
                color: #409eff;
              }
            }
          }
          .title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              width: 50px;
              margin-right: 20px;
              border-radius: 10px;
            }
            strong {
              margin-right: 20px;
              color: #000;
              font-size: 18px;
            }
          }
          .content {
            overflow: hidden;
            text-overflow: ellipsis;
            /* 超出部分省略号 */
            word-break: break-all;
            /* break-all(允许在单词内换行。) */
            display: -webkit-box;
            /* 对象作为伸缩盒子模型显示 */
            -webkit-box-orient: vertical;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2;
            /* 显示的行数 */
            line-height: 30px;
          }
        }
        .pagination {
          padding: 10px 0;
          text-align: right;
        }
      }
      .analyze-right {
        width: 50%;
        padding: 15px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 5px;
        .title {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: bold;
        }
        .stu-info {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            width: 50px;
            margin-right: 10px;
            border-radius: 10px;
          }
          span {
            margin-right: 15px;
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
  }
}
// /deep/ .v-note-wrapper .v-note-panel .v-note-show.single-show {
//   line-height: 1;
// }

/deep/.markdown-body code {
  font-size: 18px;
}
</style>

<style>
.wrapper-exam .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}

.wrapper-exam .el-drawer__body {
  overflow: hidden;
}

.wrapper-exam .language-cpp {
  font-size: 16px;
}
</style>
